import React from "react";
import { Image } from "./styles";

const MiniPreview = ({ src, onClick }) => <Image onClick={onClick} src={src}></Image>;

export { MiniPreview };
